export var DisplayAs;
(function (DisplayAs) {
    DisplayAs["Quarter"] = "quarter";
    DisplayAs["Date"] = "date";
})(DisplayAs || (DisplayAs = {}));
export var DatePickerTabBarUIds;
(function (DatePickerTabBarUIds) {
    DatePickerTabBarUIds["Quarter"] = "Quarter";
    DatePickerTabBarUIds["Day"] = "Day";
})(DatePickerTabBarUIds || (DatePickerTabBarUIds = {}));
export var PickerType;
(function (PickerType) {
    PickerType["Quarter"] = "Quarter";
    PickerType["Date"] = "Date";
})(PickerType || (PickerType = {}));
export var Quarters;
(function (Quarters) {
    Quarters["Q1"] = "Q1";
    Quarters["Q2"] = "Q2";
    Quarters["Q3"] = "Q3";
    Quarters["Q4"] = "Q4";
})(Quarters || (Quarters = {}));
export var PickerDateTimeFormat;
(function (PickerDateTimeFormat) {
    PickerDateTimeFormat["Localized"] = "localized";
    PickerDateTimeFormat["ShortLocalized"] = "shortLocalized";
})(PickerDateTimeFormat || (PickerDateTimeFormat = {}));
